import { render, staticRenderFns } from "./notice_detail.vue?vue&type=template&id=64be8205&scoped=true"
import script from "./notice_detail.vue?vue&type=script&lang=js"
export * from "./notice_detail.vue?vue&type=script&lang=js"
import style0 from "./notice_detail.vue?vue&type=style&index=0&id=64be8205&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64be8205",
  null
  
)

export default component.exports